module.exports = __webpack_public_path__ + "resource/typeface/OpenSans-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OpenSans-Regular.ttf
// module id = 441
// module chunks = 36